/* eslint-disable @typescript-eslint/no-shadow */
import React from 'react';
import Link from 'next/link';
import NextImage from '$/components/NextImage';
import useIsClient from '@/hooks/useIsClient';
import useIsMobile from '@/hooks/useIsMobile';
import styles from './index.module.scss';

interface OverviewsProps {
  categorys?: Array<{
    id: number;
    title: string;
    icon: string;
    desc: string;
    link: string;
  }>;
  allCategorys?: Array<{
    id: number;
    title: string;
    icon: string;
    desc: string;
    link: string;
  }>;
}

/** 判断菜单项是否提供了可用于 next/link 的有效地址。 */
function hasValidLink(link?: string) {
  return typeof link === 'string' && link.trim().length > 0;
}

/** 渲染能力概览卡片内容，避免无链接项重复拼装结构。 */
function OverviewCardContent({
  icon,
  title,
  isMobile,
}: {
  icon: string;
  title: string;
  isMobile: boolean;
}) {
  return (
    <div className={styles.overviewItemContent}>
      <NextImage sizes="(max-width: 768px) 28px, 32px" src={icon} width={!isMobile ? 32 : 28} height={!isMobile ? 32 : 28} alt={title} />
      <div className={styles.overviewItemName}>
        {title}
      </div>
    </div>
  );
}

/** 能力概览卡片在有链接时渲染为跳转项，否则回退为静态展示以避免 SSR 崩溃。 */
export default function Overviews(props: OverviewsProps) {
  const {
    categorys = [],
    allCategorys = [],
  } = props;
  const isClient = useIsClient();
  const isMobile = useIsMobile();

  /** 按菜单数据渲染概览卡片，并对缺失链接的数据做静态兜底。 */
  const renderCategorys = (categorys: Array<{
    id: number;
    title: string;
    icon: string;
    desc: string;
    link: string;
  }>) => {
    return categorys.map((item, index) => (
      hasValidLink(item.link)
        ? (
          // eslint-disable-next-line react/no-array-index-key
          <Link key={index} href={item.link} className={styles.overviewItem} target="_blank">
            <OverviewCardContent icon={item.icon} title={item.title} isMobile={isMobile} />
          </Link>
        )
        : (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className={styles.overviewItem} aria-disabled="true">
            <OverviewCardContent icon={item.icon} title={item.title} isMobile={isMobile} />
          </div>
        )
    ));
  };

  if (!isClient) return <div className={styles.overviews}>{renderCategorys(categorys)}</div>;

  return (
    <div
      className={styles.overviews}
    >
      {renderCategorys(categorys)}
    </div>
  );
}
